module.exports = __webpack_public_path__ + "media/venue/workshops@3x-c2de81a5.png";